import React from 'react';
import { Link } from 'react-router-dom';

/* ─────────────────────────────────────────────
   Iconos SVG (todos inline, sin dependencias)
   ───────────────────────────────────────────── */
const Icon = ({
  children,
  className = 'w-6 h-6',
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {children}
  </svg>
);

const I = {
  /* UI */
  check: (
    <polyline points="20 6 9 17 4 12" />
  ),
  chevronDown: (
    <polyline points="6 9 12 15 18 9" />
  ),
  chevronRight: (
    <polyline points="9 6 15 12 9 18" />
  ),
  play: (
    <polygon points="5 3 19 12 5 21 5 3" />
  ),
  star: (
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  ),
  heart: (
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  ),
  sparkle: (
    <>
      <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
      <path d="M19 13l.75 2.25L22 16l-2.25.75L19 19l-.75-2.25L16 16l2.25-.75L19 13z" />
    </>
  ),

  /* Features */
  edit: (
    <>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="M8.59 13.51l6.83 3.98" />
      <path d="M15.41 6.51l-6.82 3.98" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </>
  ),
  gift: (
    <>
      <polyline points="20 12 20 22 4 22 4 12" />
      <rect x="2" y="7" width="20" height="5" />
      <path d="M12 22V7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </>
  ),
  messageCircle: (
    <>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </>
  ),

  /* Categorías (reemplazan emojis) */
  rings: (
    <>
      <circle cx="9" cy="12" r="5" />
      <circle cx="15" cy="12" r="5" />
    </>
  ),
  cake: (
    <>
      <path d="M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" />
      <path d="M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" />
      <path d="M2 21h20" />
      <path d="M7 8v3M12 8v3M17 8v3" />
      <path d="M7 4h.01M12 4h.01M17 4h.01" />
    </>
  ),
  baby: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12h.01M15 12h.01" />
      <path d="M9.5 15.5c.7.5 1.5.7 2.5.7s1.8-.2 2.5-.7" />
    </>
  ),
  cross: (
    <>
      <path d="M12 2v20" />
      <path d="M7 7h10" />
    </>
  ),
  crown: (
    <>
      <path d="M2 18l3-9 4 4 3-7 3 7 4-4 3 9H2z" />
      <rect x="2" y="18" width="20" height="3" rx="1" />
    </>
  ),
  party: (
    <>
      <path d="M5.8 11.3L2 22l10.7-3.8" />
      <path d="M4 3h.01M22 8h.01M15 2h.01M22 20h.01M22 2l-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10" />
      <path d="M22 2l-7.5 7.5" />
      <path d="M13 6l-.75.25a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38" />
    </>
  ),

  /* Footer / misc */
  mail: (
    <>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="M22 7l-10 7L2 7" />
    </>
  ),
  mapPin: (
    <>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </>
  ),
  users: (
    <>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
};

/* ─────────────────────────────────────────────
   Datos
   ───────────────────────────────────────────── */
const features = [
  {
    icon: I.edit,
    title: 'Editor intuitivo',
    desc: 'Personaliza colores, fuentes, fotos y textos en minutos. No necesitas saber diseñar.',
  },
  {
    icon: I.share,
    title: 'Comparte con un link',
    desc: 'Un link único y corto para enviar por WhatsApp, Instagram, correo o donde quieras.',
  },
  {
    icon: I.bell,
    title: 'Confirmaciones en vivo',
    desc: 'Tus invitados confirman asistencia directamente. Ve la lista actualizarse en tiempo real.',
  },
  {
    icon: I.calendar,
    title: 'Recordatorios automáticos',
    desc: 'Enviamos recordatorios por ti para que nadie se olvide de tu evento.',
  },
  {
    icon: I.gift,
    title: 'Lista de regalos',
    desc: 'Agrega tu mesa de regalos o datos bancarios para que tus invitados te sorprendan.',
  },
  {
    icon: I.messageCircle,
    title: 'Mensajes de cariño',
    desc: 'Recibe mensajes y fotos de tus invitados en un muro digital inolvidable.',
  },
];

const steps = [
  {
    n: '01',
    title: 'Elige tu plantilla',
    desc: 'Explora cientos de diseños para bodas, XV años, cumpleaños y más.',
  },
  {
    n: '02',
    title: 'Personalízala',
    desc: 'Cambia colores, fotos, textos y agrega los detalles de tu evento.',
  },
  {
    n: '03',
    title: 'Comparte tu link',
    desc: 'Envía tu invitación por WhatsApp, redes sociales o correo.',
  },
  {
    n: '04',
    title: 'Administra tu evento',
    desc: 'Recibe confirmaciones, mensajes y organiza todo desde un solo lugar.',
  },
];

const categories = [
  { icon: I.rings, name: 'Bodas', bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-700', iconBg: 'bg-rose-100' },
  { icon: I.cake, name: 'Cumpleaños', bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-700', iconBg: 'bg-amber-100' },
  { icon: I.baby, name: 'Baby Shower', bg: 'bg-sky-50', border: 'border-sky-200', text: 'text-sky-700', iconBg: 'bg-sky-100' },
  { icon: I.cross, name: 'Bautizos', bg: 'bg-stone-50', border: 'border-stone-200', text: 'text-stone-700', iconBg: 'bg-stone-100' },
  { icon: I.crown, name: 'XV Años', bg: 'bg-fuchsia-50', border: 'border-fuchsia-200', text: 'text-fuchsia-700', iconBg: 'bg-fuchsia-100' },
  { icon: I.party, name: 'Fiestas', bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-700', iconBg: 'bg-emerald-100' },
];

const testimonials = [
  {
    name: 'María González',
    role: 'Novia feliz',
    text: 'Creé la invitación de mi boda en 10 minutos. Mis invitados quedaron encantados y todo llegó perfecto al celular.',
    rating: 5,
    avatar: 'MG',
  },
  {
    name: 'Carlos Ramírez',
    role: 'Papá primerizo',
    text: 'El baby shower de mi hija fue un éxito gracias a Go Fiesta. Las confirmaciones en vivo me ahorraron muchísimo tiempo.',
    rating: 5,
    avatar: 'CR',
  },
  {
    name: 'Laura Mendoza',
    role: 'Quinceañera',
    text: 'La plantilla que elegí era hermosa y pude personalizarla con mis colores favoritos. Todos me preguntaron dónde la hice.',
    rating: 5,
    avatar: 'LM',
  },
];

const plans = [
  {
    name: 'Gratis',
    price: '$0',
    period: 'por 3 días',
    desc: 'Perfecto para probar la plataforma.',
    features: [
      '1 invitación activa',
      'Plantillas básicas',
      'Hasta 50 invitados',
      'Confirmaciones por link',
    ],
    cta: 'Empezar gratis',
    highlight: false,
  },
  {
    name: 'Premium',
    price: '$99',
    period: 'pago único',
    desc: 'Todo lo que necesitas para tu evento especial.',
    features: [
      'Invitaciones ilimitadas',
      'Todas las plantillas',
      'Invitados ilimitados',
      'Lista de regalos',
      'Muro de mensajes',
      'Recordatorios automáticos',
      'Dominio personalizado',
    ],
    cta: 'Elegir Premium',
    highlight: true,
  },
];

const faqs = [
  {
    q: '¿Necesito saber diseñar para usar Go Fiesta?',
    a: 'Para nada. Nuestras plantillas están diseñadas por profesionales. Solo eliges, cambias textos y fotos, y listo.',
  },
  {
    q: '¿Puedo usarlo sin tarjeta de crédito?',
    a: 'Sí. El plan gratuito dura 3 días y no requiere ningún método de pago. Solo crea tu cuenta y empieza.',
  },
  {
    q: '¿Cómo reciben la invitación mis invitados?',
    a: 'Compartes un link único por WhatsApp, Instagram, correo o donde prefieras. No necesitan app, solo abren el link.',
  },
  {
    q: '¿Puedo cambiar la invitación después de enviarla?',
    a: 'Claro. Puedes editarla las veces que quieras y los invitados verán los cambios al instante.',
  },
  {
    q: '¿Qué pasa cuando termina mi evento?',
    a: 'Tu invitación sigue activa como recuerdo. Puedes descargar las confirmaciones y mensajes cuando quieras.',
  },
];

/* ─────────────────────────────────────────────
   Landing
   ───────────────────────────────────────────── */
export default function Landing() {
  return (
    <div className="min-h-screen bg-stone-50 text-stone-800 font-sans antialiased">
      {/* ═══════ HEADER ═══════ */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-stone-50/80 border-b border-stone-200/60">
        <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 font-extrabold text-xl text-stone-900">
            <span className="w-9 h-9 rounded-lg bg-brand-500 text-white grid place-items-center text-sm font-black tracking-tight">
              GF
            </span>
            Go Fiesta
          </Link>

          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-stone-500">
            <a href="#features" className="hover:text-brand-600 transition-colors">Características</a>
            <a href="#como-funciona" className="hover:text-brand-600 transition-colors">Cómo funciona</a>
            <a href="#plantillas" className="hover:text-brand-600 transition-colors">Plantillas</a>
            <a href="#precios" className="hover:text-brand-600 transition-colors">Precios</a>
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="hidden sm:inline-flex text-sm font-semibold text-stone-500 hover:text-brand-600 transition-colors"
            >
              Iniciar sesión
            </Link>
            <Link
              to="/register"
              className="text-sm font-semibold bg-brand-500 text-white px-5 py-2.5 rounded-lg hover:bg-brand-600 transition-colors"
            >
              Crear cuenta
            </Link>
          </div>
        </div>
      </header>

      {/* ═══════ HERO ═══════ */}
      <section className="relative overflow-hidden">
        {/* Decoración sutil de fondo */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-10 -left-32 w-[500px] h-[500px] bg-brand-200/40 rounded-full blur-[120px]" />
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-amber-200/30 rounded-full blur-[100px]" />
        </div>

        <div className="max-w-6xl mx-auto px-4 pt-16 pb-20 md:pt-24 md:pb-28 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Texto */}
          <div>
            <span className="inline-flex items-center gap-2 bg-brand-50 border border-brand-200 text-brand-700 text-xs font-bold px-3.5 py-1.5 rounded-full mb-6">
              <Icon className="w-3.5 h-3.5">{I.sparkle}</Icon>
              +50,000 eventos creados
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 leading-[1.1] tracking-tight">
              Crea, comparte y administra{' '}
              <span className="text-brand-500">tu invitación digital</span>
            </h1>

            <p className="mt-6 text-lg text-stone-500 max-w-lg leading-relaxed">
              Bodas, cumpleaños, baby showers, bautizos y más. Elige una plantilla,
              personalízala y comparte un link único con tus invitados en minutos.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Link
                to="/register"
                className="bg-brand-500 text-white font-semibold px-8 py-4 rounded-xl hover:bg-brand-600 transition-colors text-center shadow-lg shadow-brand-500/20"
              >
                Empezar gratis (3 días)
              </Link>
              <Link
                to="/login"
                className="bg-white border border-stone-300 text-stone-700 font-semibold px-8 py-4 rounded-xl hover:bg-stone-50 transition-colors text-center flex items-center justify-center gap-2"
              >
                <Icon className="w-4 h-4">{I.play}</Icon>
                Ver demo
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-stone-500">
              {[
                'Sin tarjeta',
                'Listo en 5 min',
                '100% editable',
              ].map((t) => (
                <span key={t} className="flex items-center gap-1.5">
                  <Icon className="w-4 h-4 text-emerald-500">{I.check}</Icon>
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* Mockup de invitación */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Glow */}
            <div className="absolute -inset-6 bg-brand-300/20 rounded-[2rem] blur-3xl" />

            {/* Tarjeta principal */}
            <div className="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl shadow-stone-900/10 p-8 border border-stone-100 rotate-1 hover:rotate-0 transition-transform duration-500">
              <div className="flex items-center justify-between text-[11px] text-stone-400 font-semibold uppercase tracking-widest">
                <span>Invitación</span>
                <span className="bg-emerald-50 text-emerald-700 border border-emerald-200 px-2 py-0.5 rounded text-[10px]">
                  En vivo
                </span>
              </div>

              <div className="mt-8 text-center">
                <p className="text-sm text-stone-400 tracking-wide">Te invitamos a la boda de</p>
                <h3 className="mt-2 text-3xl font-serif font-bold text-stone-900 tracking-tight">
                  Ana &amp; Carlos
                </h3>
                <div className="my-6 flex items-center justify-center gap-3">
                  <div className="h-px w-14 bg-stone-200" />
                  <Icon className="w-4 h-4 text-brand-400">{I.heart}</Icon>
                  <div className="h-px w-14 bg-stone-200" />
                </div>

                <div className="grid grid-cols-3 gap-2 text-center">
                  <div>
                    <p className="text-[10px] text-stone-400 font-semibold uppercase">Sáb</p>
                    <p className="text-2xl font-bold text-stone-900">15</p>
                    <p className="text-xs text-stone-500">Nov</p>
                  </div>
                  <div className="border-x border-stone-100">
                    <p className="text-[10px] text-stone-400 font-semibold uppercase">Hora</p>
                    <p className="text-2xl font-bold text-stone-900">6:00</p>
                    <p className="text-xs text-stone-500">PM</p>
                  </div>
                  <div>
                    <p className="text-[10px] text-stone-400 font-semibold uppercase">Lugar</p>
                    <p className="text-sm font-bold text-stone-900 leading-snug">
                      Hacienda<br />Los Robles
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 flex gap-2">
                <button className="flex-1 bg-brand-500 text-white text-sm font-semibold py-3 rounded-lg hover:bg-brand-600 transition-colors">
                  Confirmar
                </button>
                <button className="flex-1 border border-stone-200 text-stone-600 text-sm font-semibold py-3 rounded-lg hover:bg-stone-50 transition-colors">
                  Ver mapa
                </button>
              </div>
            </div>

            {/* Floating card: confirmaciones */}
            <div className="absolute -top-3 -left-6 bg-white rounded-2xl shadow-xl shadow-stone-900/10 p-3.5 flex items-center gap-3 border border-stone-100">
              <div className="w-10 h-10 rounded-full bg-emerald-50 border border-emerald-200 grid place-items-center">
                <Icon className="w-5 h-5 text-emerald-600">{I.check}</Icon>
              </div>
              <div>
                <p className="text-[11px] text-stone-400 font-medium">Confirmaciones</p>
                <p className="font-bold text-stone-900 text-sm">+128 hoy</p>
              </div>
            </div>

            {/* Floating card: mensajes */}
            <div className="absolute -bottom-3 -right-4 bg-white rounded-2xl shadow-xl shadow-stone-900/10 p-3.5 flex items-center gap-3 border border-stone-100">
              <div className="w-10 h-10 rounded-full bg-brand-50 border border-brand-200 grid place-items-center">
                <Icon className="w-5 h-5 text-brand-500">{I.heart}</Icon>
              </div>
              <div>
                <p className="text-[11px] text-stone-400 font-medium">Mensajes</p>
                <p className="font-bold text-stone-900 text-sm">"No faltes!"</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ STATS ═══════ */}
      <section className="border-y border-stone-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {[
            { n: '50K+', l: 'Eventos creados' },
            { n: '2M+', l: 'Invitados felices' },
            { n: '4.9', l: 'Calificación promedio' },
            { n: '150+', l: 'Plantillas disponibles' },
          ].map((s) => (
            <div key={s.l}>
              <p className="text-3xl md:text-4xl font-extrabold text-brand-500">{s.n}</p>
              <p className="mt-1 text-sm text-stone-500">{s.l}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ═══════ FEATURES ═══════ */}
      <section id="features" className="max-w-6xl mx-auto px-4 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brand-600 font-bold text-xs uppercase tracking-widest">
            Características
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-stone-900 tracking-tight">
            Todo lo que necesitas para tu evento
          </h2>
          <p className="mt-4 text-stone-500 text-lg leading-relaxed">
            Una plataforma completa para crear, compartir y administrar invitaciones
            digitales como un profesional.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group bg-white rounded-2xl p-6 border border-stone-200 hover:border-brand-300 hover:shadow-lg hover:shadow-brand-500/5 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-50 border border-brand-200 text-brand-600 grid place-items-center mb-5 group-hover:bg-brand-500 group-hover:text-white group-hover:border-brand-500 transition-colors duration-300">
                <Icon className="w-5 h-5">{f.icon}</Icon>
              </div>
              <h3 className="text-lg font-bold text-stone-900">{f.title}</h3>
              <p className="mt-2 text-stone-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ═══════ CÓMO FUNCIONA ═══════ */}
      <section id="como-funciona" className="bg-stone-900 text-white py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <span className="text-brand-400 font-bold text-xs uppercase tracking-widest">
              Cómo funciona
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight">
              De la idea a la invitación en{' '}
              <span className="text-brand-400">4 pasos</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {steps.map((s, i) => (
              <div
                key={s.n}
                className="relative bg-stone-800/60 rounded-2xl p-6 border border-stone-700/50 hover:border-brand-500/40 transition-colors"
              >
                <span className="text-5xl font-black text-brand-500/30">{s.n}</span>
                <h3 className="mt-4 text-lg font-bold">{s.title}</h3>
                <p className="mt-2 text-stone-400 text-sm leading-relaxed">{s.desc}</p>

                {i < steps.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 items-center justify-center text-stone-600">
                    <Icon className="w-5 h-5">{I.chevronRight}</Icon>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ PLANTILLAS / CATEGORÍAS ═══════ */}
      <section id="plantillas" className="max-w-6xl mx-auto px-4 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brand-600 font-bold text-xs uppercase tracking-widest">
            Plantillas
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-stone-900 tracking-tight">
            Para cada momento especial
          </h2>
          <p className="mt-4 text-stone-500 text-lg leading-relaxed">
            Explora nuestras plantillas diseñadas por profesionales para todo tipo de eventos.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((c) => (
            <Link
              to="/register"
              key={c.name}
              className={`group ${c.bg} border ${c.border} rounded-2xl p-6 flex flex-col items-center justify-center text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer aspect-square`}
            >
              <div
                className={`w-14 h-14 rounded-2xl ${c.iconBg} ${c.text} grid place-items-center mb-3 group-hover:scale-110 transition-transform duration-300`}
              >
                <Icon className="w-7 h-7">{c.icon}</Icon>
              </div>
              <span className={`font-bold text-sm ${c.text}`}>{c.name}</span>
            </Link>
          ))}
        </div>
      </section>

      {/* ═══════ TESTIMONIOS ═══════ */}
      <section className="bg-white border-y border-stone-200 py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <span className="text-brand-600 font-bold text-xs uppercase tracking-widest">
              Testimonios
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-stone-900 tracking-tight">
              Lo que dicen nuestros usuarios
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="bg-stone-50 rounded-2xl p-6 border border-stone-200 hover:shadow-md transition-shadow"
              >
                <div className="flex gap-0.5 text-amber-400 mb-4">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Icon key={j} className="w-4 h-4 fill-amber-400 stroke-amber-400">
                      {I.star}
                    </Icon>
                  ))}
                </div>
                <p className="text-stone-600 leading-relaxed text-[15px]">
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="mt-6 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-brand-500 text-white grid place-items-center font-bold text-sm">
                    {t.avatar}
                  </div>
                  <div>
                    <p className="font-bold text-stone-900 text-sm">{t.name}</p>
                    <p className="text-xs text-stone-500">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════ PRECIOS ═══════ */}
      <section id="precios" className="max-w-6xl mx-auto px-4 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brand-600 font-bold text-xs uppercase tracking-widest">
            Precios
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-stone-900 tracking-tight">
            Planes simples y transparentes
          </h2>
          <p className="mt-4 text-stone-500 text-lg">
            Empieza gratis. Actualiza cuando quieras.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto items-start">
          {plans.map((p) => (
            <div
              key={p.name}
              className={`relative rounded-2xl p-8 ${
                p.highlight
                  ? 'bg-brand-500 text-white shadow-2xl shadow-brand-500/25 md:scale-[1.03]'
                  : 'bg-white border border-stone-200'
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-400 text-stone-900 text-xs font-bold px-4 py-1 rounded-full shadow-sm">
                  MÁS POPULAR
                </span>
              )}

              <h3
                className={`text-xl font-bold ${
                  p.highlight ? 'text-white' : 'text-stone-900'
                }`}
              >
                {p.name}
              </h3>
              <p
                className={`mt-1 text-sm ${
                  p.highlight ? 'text-white/80' : 'text-stone-500'
                }`}
              >
                {p.desc}
              </p>

              <div className="mt-6 flex items-baseline gap-2">
                <span
                  className={`text-5xl font-extrabold ${
                    p.highlight ? 'text-white' : 'text-stone-900'
                  }`}
                >
                  {p.price}
                </span>
                <span
                  className={`text-sm ${
                    p.highlight ? 'text-white/80' : 'text-stone-500'
                  }`}
                >
                  {p.period}
                </span>
              </div>

              <ul className="mt-8 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Icon
                      className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                        p.highlight ? 'text-white' : 'text-emerald-500'
                      }`}
                    >
                      {I.check}
                    </Icon>
                    <span className={p.highlight ? 'text-white/90' : 'text-stone-600'}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <Link
                to="/register"
                className={`mt-8 block text-center font-semibold py-3.5 rounded-xl transition-colors ${
                  p.highlight
                    ? 'bg-white text-brand-600 hover:bg-stone-100'
                    : 'bg-stone-900 text-white hover:bg-stone-800'
                }`}
              >
                {p.cta}
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* ═══════ FAQ ═══════ */}
      <section className="max-w-3xl mx-auto px-4 py-20 md:py-28">
        <div className="text-center mb-14">
          <span className="text-brand-600 font-bold text-xs uppercase tracking-widest">
            FAQ
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-stone-900 tracking-tight">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f) => (
            <details
              key={f.q}
              className="group bg-white rounded-2xl border border-stone-200 overflow-hidden open:shadow-md transition-shadow"
            >
              <summary className="cursor-pointer list-none p-5 flex items-center justify-between font-semibold text-stone-900 hover:bg-stone-50 transition-colors">
                <span>{f.q}</span>
                <Icon className="w-5 h-5 text-stone-400 flex-shrink-0 ml-4 group-open:rotate-180 transition-transform duration-200">
                  {I.chevronDown}
                </Icon>
              </summary>
              <div className="px-5 pb-5 text-stone-600 leading-relaxed">{f.a}</div>
            </details>
          ))}
        </div>
      </section>

      {/* ═══════ CTA FINAL ═══════ */}
      <section className="max-w-6xl mx-auto px-4 pb-20 md:pb-28">
        <div className="relative overflow-hidden rounded-3xl bg-brand-500 p-10 md:p-16 text-center text-white">
          {/* Decoración */}
          <div className="absolute -top-24 -right-24 w-80 h-80 bg-white/10 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-brand-700/50 rounded-full blur-3xl" />

          <div className="relative">
            <h2 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight">
              ¿Listo para crear tu<br className="hidden sm:block" /> invitación perfecta?
            </h2>
            <p className="mt-4 text-white/85 text-lg max-w-2xl mx-auto leading-relaxed">
              Únete a miles de personas que ya confían en Go Fiesta para sus eventos
              más especiales.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/register"
                className="bg-white text-brand-600 font-bold px-8 py-4 rounded-xl hover:bg-stone-100 transition-colors shadow-lg"
              >
                Crear mi cuenta gratis
              </Link>
              <Link
                to="/login"
                className="bg-white/10 backdrop-blur-sm border border-white/25 text-white font-semibold px-8 py-4 rounded-xl hover:bg-white/20 transition-colors"
              >
                Ya tengo cuenta
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ FOOTER ═══════ */}
      <footer className="bg-stone-900 text-stone-400">
        <div className="max-w-6xl mx-auto px-4 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Marca */}
          <div>
            <div className="flex items-center gap-2.5 font-extrabold text-xl text-white mb-4">
              <span className="w-9 h-9 rounded-lg bg-brand-500 text-white grid place-items-center text-sm font-black">
                GF
              </span>
              Go Fiesta
            </div>
            <p className="text-sm leading-relaxed">
              La forma más fácil de crear invitaciones digitales memorables para tus
              eventos.
            </p>
          </div>

          {/* Producto */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm">Producto</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#features" className="hover:text-white transition-colors">Características</a></li>
              <li><a href="#plantillas" className="hover:text-white transition-colors">Plantillas</a></li>
              <li><a href="#precios" className="hover:text-white transition-colors">Precios</a></li>
              <li><a href="#como-funciona" className="hover:text-white transition-colors">Cómo funciona</a></li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm">Empresa</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Sobre nosotros</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contacto</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Soporte</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Términos de uso</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacidad</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Cookies</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800">
          <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
            <p>&copy; 2026 Go Fiesta. Todos los derechos reservados.</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-white transition-colors">Instagram</a>
              <a href="#" className="hover:text-white transition-colors">TikTok</a>
              <a href="#" className="hover:text-white transition-colors">Facebook</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}